/** Replaced at build time by vite.config.ts (`define`); absent in tests and in the admin build. */
declare const __APP_VERSION__: string | undefined;

/** The portal's version for the Support page: `0.1.0+<short sha>` in a build, `dev` otherwise. */
export function appVersion(): string {
  return typeof __APP_VERSION__ === 'string' && __APP_VERSION__ ? __APP_VERSION__ : 'dev';
}

/** The release alone (`0.1.0`), for the footer badge: package.json's version, the commit dropped. */
export function appRelease(): string {
  return appVersion().split('+')[0];
}
